import { useState, type MouseEvent, type ReactNode } from 'react';
import SignupGateModal from '@/shared/ui/SignupGateModal';
import { useProfile } from '@/routes/Providers/ProfileProvider';
import { track } from '@/shared/utils/track';

// Logged-out chrome exists only on the public routes (the market page, a
// KOL's profile); the nav targets need an account, so a logged-out click
// opens the sign-up gate instead of navigating.
export function useGatedNav(location: 'header' | 'footer'): {
  onNavClick: (e: MouseEvent, label: string) => void;
  openGate: () => void;
  gateEl: ReactNode;
} {
  const { profile } = useProfile();
  const [gateOpen, setGateOpen] = useState(false);
  return {
    onNavClick: (e, label) => {
      if (profile) {
        track('nav_clicked', { location, label });
        return;
      }
      e.preventDefault();
      setGateOpen(true);
    },
    openGate: () => setGateOpen(true),
    gateEl: gateOpen && (
      <SignupGateModal
        variant="explore"
        source="nav"
        onClose={() => setGateOpen(false)}
      />
    ),
  };
}
